import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse } from 'types';

import { api } from 'utils';

const useExchangeApprove = (): UseMutationResult<
  [],
  ErrorResponse,
  { id: string }
> => {
  return useMutation(({ id }) =>
    api.put(`${url.approveExchange}/${id}/approve`)
  );
};
export default useExchangeApprove;
